module.exports = __webpack_public_path__ + "static/opener-text-sml-a74d3dec683e5de902c448a90e0701c1.png";